import { CalendarDays } from 'lucide-react';
import GameCalendar from './GameCalendar';

// Calendar shown at the top of the NBA / NFL picks pages — tap a date to list every game that day.
export const PicksCalendar = ({ league }) => (
  <details open className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-3" data-testid="picks-calendar">
    <summary className="flex cursor-pointer items-center gap-1.5 text-sm font-bold text-amber-300" data-testid="picks-calendar-toggle">
      <CalendarDays className="h-4 w-4" />Game calendar · tap any date for its games
    </summary>
    <div className="mt-3"><GameCalendar initialLeague={league} /></div>
  </details>
);

export default PicksCalendar;
